import { getTaxAccountantFinancesAccounts } from "../../apis/tax-accountant-finance/auth";
import { viewLoading } from "../loading";
import { isEmpty } from "../lodashExtend";

export const isTaxAccountantAccountCheck = async () => {
  viewLoading('홈택스 설정 정보 확인중입니다.');
  const account = await getTaxAccountantFinancesAccounts("tax-accountant-hometax")
    .then((res) => {
      res = res.data.accounts.find((account) => account.orgCd === "tax-accountant-hometax");
      return res;
      // setAccountInfo(res);
    })
    .catch((err) => {
      console.error(err);
    })
    .finally(() =>
      viewLoading(false)
    );

  // if (isEmpty(account) || !account.idx || !account.agentId)
  if (isEmpty(account) || !account.idx)
    return false;
  return true;
};